import { MaintenanceIllustration, FullscreenCentered } from '@diana/core';
import { Button, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ERROR_PAGES_NS } from './i18n';

export function SessionTimeout(props: {
  type: 'timeout' | 'unknown' | 'unexpectedEnvironment';
  onRetry: () => void;
}) {
  const { type, onRetry } = props;

  const { t } = useTranslation(ERROR_PAGES_NS);
  const { breakpoints } = useTheme();
  const isTabletOrMobile = useMediaQuery(breakpoints.down('md'));
  const messageMap = {
    timeout: t('timeout'),
    unexpectedEnvironment: t('unexpectedEnvironment'),
    unknown: t('unknown'),
  };

  return (
    <FullscreenCentered>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        width={isTabletOrMobile ? '100%' : '534px'}
      >
        <MaintenanceIllustration sx={{ mb: '32px!important' }} />
        <Typography variant="h4" sx={{ textAlign: 'center', fontSize: 18 }}>
          {messageMap[type] || t('unknown')}
        </Typography>
        <Typography sx={{ textAlign: 'center', color: ({ palette }) => palette.text.secondary }}>
          {t('hint')}
        </Typography>
        <Button variant="contained" onClick={onRetry} sx={{ marginTop: '16px!important' }}>
          {t('button')}
        </Button>
      </Stack>
    </FullscreenCentered>
  );
}

export const Component = SessionTimeout;
